// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mMaxWidth850{max-width:850px}.mFontBold{font-weight:700 !important}.mBorderTopBold{border-top:solid #dee2e6 5px}", ""]);
// Exports
module.exports = exports;
